import Client from "./client";

export const GetCalendar = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/calendar?projectId=${projectId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const UpdateWorkweek = ({projectId, workweek, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.put(`/api/calendar/workweek`, {projectId, workweek}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.workweek);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateHoliday = ({projectId, name, date, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/calendar/holidays`, {projectId, name, date}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.holiday);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteHoliday = ({holidayId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/calendar/holidays/${holidayId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const CreateWorkweekPeriod = ({projectId, name, startdate, enddate, workweek, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/calendar/workweek-periods`, {projectId, name, startdate, enddate, workweek}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.workWeekPeriod);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const DeleteWorkweekPeriod = ({workWeekPeriodId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.delete(`/api/calendar/workweek-periods/${workWeekPeriodId}`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
